import {
  FilterMode,
  EditionDocumentation_OrderBy,
  EditionDocumentation,
  SortOrder,
  EditionDocumentation_Filter,
} from "../../../api/graphql";
import { getApiInstance } from "../../../api";
import { nullToUndefinedRecursive } from "../../../common/utils";

export const editionDocumentationService = {
  createOne: () => (): Promise<string> => new Promise(() => ""),
  getOne: async (id: string, accessToken: string, activityStore: any) => {
    const api = getApiInstance(accessToken, activityStore);
    const result = await api.editionDocumentationOne({ id });
    return result.editionDocumentationOne as EditionDocumentation;
  },
  getFilteredList: async (
    accessToken: string,
    offset: number,
    take: number,
    searchValue: string,
    _language: string = "es",
    orderBy: EditionDocumentation_OrderBy[] | null = null,
    filter: EditionDocumentation_Filter | null = null,
    activityStore: any
  ) => {
    const api = getApiInstance(accessToken, activityStore);

    let where: EditionDocumentation_Filter | undefined;
    if (searchValue !== "") {
      where = {
        documentName: { contains: searchValue, mode: FilterMode.Insensitive },
      };
    }

    if (filter) {
      if (where) {
        where = { AND: [filter, where] };
      } else {
        where = filter;
      }
    }

    const result = await api.editionDocumentationListWithOffset({
      offset,
      take,
      orderBy: orderBy ? orderBy : [{ documentName: SortOrder.Asc }],
      where,
    });
    const list = nullToUndefinedRecursive(
      result.editionDocumentationListWithOffset
    ) as EditionDocumentation[];
    return { list, orderBy };
  },
};
